import React from 'react';
import { Monitor, Mail, FileText, Target, TrendingUp, Settings, BarChart, CheckCircle2, Home, Users, Star, Moon, HelpCircle, Smartphone, Layers } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { Input } from '../components/ui/Input';
import { useToast } from '../components/ui/Toast';
import { Badge } from '../components/ui/Badge';
interface AdvertisingPageProps {
  onNavigate: (page: string) => void;
}
export function AdvertisingPage({
  onNavigate
}: AdvertisingPageProps) {
  const {
    success
  } = useToast();
  const pricingData = [{
    format: 'Баннер на главной (TOP)',
    placement: '1140×250',
    duration: '1 неделя',
    impressions: '~40,000',
    price: '50 000 ₽'
  }, {
    format: 'Баннер на главной (после отзывов)',
    placement: '1140×250',
    duration: '2 недели',
    impressions: '~60,000',
    price: '35 000 ₽'
  }, {
    format: 'Баннер в каталоге (сайдбар)',
    placement: '300×600',
    duration: '1 неделя',
    impressions: '~25,000',
    price: '20 000 ₽'
  }, {
    format: 'Каталог — между карточками',
    placement: 'Нативная карточка',
    duration: '2 недели',
    impressions: '~30,000',
    price: '12 000 ₽'
  }, {
    format: 'Закреп астролога в топе',
    placement: 'Карточка',
    duration: '1 месяц',
    impressions: '~100,000',
    price: '15 000 ₽'
  }, {
    format: 'Профиль астролога — рекомендации',
    placement: 'Карточка',
    duration: '1 месяц',
    impressions: '~45,000',
    price: '10 000 ₽'
  }, {
    format: 'Баннер в блоге (внутри статьи)',
    placement: '728×90',
    duration: '1 месяц',
    impressions: '~60,000',
    price: '12 000 ₽'
  }, {
    format: 'Блог — сайдбар',
    placement: '300×600',
    duration: '2 недели',
    impressions: '~25,000',
    price: '15 000 ₽'
  }, {
    format: 'Гороскоп — баннер',
    placement: '728×90',
    duration: '2 недели',
    impressions: '~45,000',
    price: '18 000 ₽'
  }, {
    format: 'Гороскоп — сайдбар',
    placement: '300×250',
    duration: '1 неделя',
    impressions: '~40,000',
    price: '12 000 ₽'
  }, {
    format: 'Лунный календарь — баннер',
    placement: '728×90',
    duration: '2 недели',
    impressions: '~30,000',
    price: '14 000 ₽'
  }, {
    format: 'Бесплатная карта — после результата',
    placement: '728×90',
    duration: '1 месяц',
    impressions: '~15,000',
    price: '22 000 ₽'
  }, {
    format: 'Совместимость — после результата',
    placement: '728×90',
    duration: '1 месяц',
    impressions: '~10,000',
    price: '20 000 ₽'
  }, {
    format: 'Результат отчёта — апсейл',
    placement: 'Нативная карточка',
    duration: '1 месяц',
    impressions: '~5,000',
    price: '25 000 ₽'
  }, {
    format: 'Страница услуг — кросс-продажи',
    placement: 'Нативная карточка',
    duration: '1 месяц',
    impressions: '~8,000',
    price: '16 000 ₽'
  }, {
    format: 'FAQ — баннер',
    placement: '728×90',
    duration: '1 месяц',
    impressions: '~4,000',
    price: '8 000 ₽'
  }, {
    format: 'Мобильный sticky баннер',
    placement: '320×50',
    duration: '1 неделя',
    impressions: '~350,000',
    price: '30 000 ₽'
  }, {
    format: 'Нативная статья',
    placement: 'Блог + Анонс',
    duration: 'Навсегда',
    impressions: '~15,000',
    price: '35 000 ₽'
  }, {
    format: 'Email-рассылка (отдельное письмо)',
    placement: 'Отдельное письмо',
    duration: '1 рассылка',
    impressions: '~45,000',
    price: '40 000 ₽'
  }, {
    format: 'Email-рассылка (блок в дайджесте)',
    placement: 'Блок в дайджесте',
    duration: '1 рассылка',
    impressions: '~45,000',
    price: '25 000 ₽'
  }];
  const placementMap = [{
    title: 'Главная',
    icon: <Home className="w-5 h-5 text-indigo-500" data-id="element-19700" />,
    slots: 2,
    types: ['Banner'],
    priceRange: '35 000 ₽ - 50 000 ₽',
    impressions: '~100,000/мес',
    color: 'bg-indigo-50 border-indigo-100'
  }, {
    title: 'Каталог астрологов',
    icon: <Users className="w-5 h-5 text-blue-500" data-id="element-19701" />,
    slots: 3,
    types: ['Banner', 'Pinned', 'Native'],
    priceRange: '10 000 ₽ - 20 000 ₽',
    impressions: '~150,000/мес',
    color: 'bg-blue-50 border-blue-100'
  }, {
    title: 'Блог',
    icon: <FileText className="w-5 h-5 text-emerald-500" data-id="element-19702" />,
    slots: 2,
    types: ['Banner', 'Native'],
    priceRange: '12 000 ₽ - 15 000 ₽',
    impressions: '~85,000/мес',
    color: 'bg-emerald-50 border-emerald-100'
  }, {
    title: 'Гороскоп',
    icon: <Star className="w-5 h-5 text-amber-500" data-id="element-19703" />,
    slots: 2,
    types: ['Banner', 'Native'],
    priceRange: '12 000 ₽ - 18 000 ₽',
    impressions: '~85,000/мес',
    color: 'bg-amber-50 border-amber-100'
  }, {
    title: 'Сервисные страницы',
    icon: <Layers className="w-5 h-5 text-purple-500" data-id="element-19704" />,
    slots: 4,
    types: ['Native'],
    priceRange: '16 000 ₽ - 25 000 ₽',
    impressions: '~38,000/мес',
    color: 'bg-purple-50 border-purple-100'
  }, {
    title: 'Лунный календарь',
    icon: <Moon className="w-5 h-5 text-slate-500" data-id="element-19705" />,
    slots: 1,
    types: ['Banner'],
    priceRange: '14 000 ₽',
    impressions: '~30,000/мес',
    color: 'bg-slate-100 border-slate-200'
  }, {
    title: 'FAQ',
    icon: <HelpCircle className="w-5 h-5 text-rose-500" data-id="element-19706" />,
    slots: 1,
    types: ['Banner'],
    priceRange: '8 000 ₽',
    impressions: '~4,000/мес',
    color: 'bg-rose-50 border-rose-100'
  }, {
    title: 'Email',
    icon: <Mail className="w-5 h-5 text-teal-500" data-id="element-19707" />,
    slots: 2,
    types: ['Email'],
    priceRange: '25 000 ₽ - 40 000 ₽',
    impressions: '~45,000/рассылка',
    color: 'bg-teal-50 border-teal-100'
  }, {
    title: 'Мобильный',
    icon: <Smartphone className="w-5 h-5 text-cyan-500" data-id="element-19708" />,
    slots: 1,
    types: ['Banner'],
    priceRange: '30 000 ₽',
    impressions: '~350,000/мес',
    color: 'bg-cyan-50 border-cyan-100'
  }];
  return <div className="w-full bg-slate-50 pb-24" data-id="element-19709">
      <div className="bg-white border-b border-slate-200 pt-8 pb-16" data-id="element-19710">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19711">
          <Breadcrumbs items={[{
          label: 'Главная',
          onClick: () => onNavigate('home')
        }, {
          label: 'Реклама'
        }]} className="mb-8" data-id="element-19712" />
          <div className="text-center max-w-4xl mx-auto mt-8" data-id="element-19713">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-19714">
              Реклама на платформе
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-19715">
              Доступ к целевой аудитории, заинтересованной в самопознании,
              психологии и эзотерике. Более 100 000 уникальных посетителей в
              месяц.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12" data-id="element-19716">
        {/* Audience Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20" data-id="element-19717">
          <Card padding="lg" className="text-center" data-id="element-19718">
            <div className="text-3xl font-bold text-primary mb-2" data-id="element-19719">120 000+</div>
            <div className="text-sm text-slate-600" data-id="element-19720">
              уникальных посетителей/мес
            </div>
          </Card>
          <Card padding="lg" className="text-center" data-id="element-19721">
            <div className="text-3xl font-bold text-primary mb-2" data-id="element-19722">85%</div>
            <div className="text-sm text-slate-600" data-id="element-19723">женщины 25-45 лет</div>
          </Card>
          <Card padding="lg" className="text-center" data-id="element-19724">
            <div className="text-3xl font-bold text-primary mb-2" data-id="element-19725">4.2 мин</div>
            <div className="text-sm text-slate-600" data-id="element-19726">средняя сессия</div>
          </Card>
          <Card padding="lg" className="text-center" data-id="element-19727">
            <div className="text-3xl font-bold text-primary mb-2" data-id="element-19728">45 000</div>
            <div className="text-sm text-slate-600" data-id="element-19729">email-подписчиков</div>
          </Card>
        </div>

        <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center" data-id="element-19730">
          Рекламные форматы
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-19731">
          <Card padding="lg" className="flex flex-col" data-id="element-19732">
            <div className="w-full h-32 bg-slate-100 rounded-xl mb-6 flex flex-col items-center justify-center border border-slate-200 relative overflow-hidden" data-id="element-19733">
              {/* Mockup visual */}
              <div className="w-full h-4 bg-slate-200 absolute top-0" data-id="element-19734"></div>
              <div className="w-3/4 h-12 bg-indigo-100 border border-indigo-200 rounded flex items-center justify-center text-indigo-500 text-xs font-medium" data-id="element-19735">
                Место для баннера
              </div>
              <div className="w-full h-8 bg-slate-200 absolute bottom-0 flex gap-2 px-4 items-center" data-id="element-19736">
                <div className="w-8 h-8 rounded-full bg-slate-300" data-id="element-19737"></div>
                <div className="w-16 h-2 bg-slate-300 rounded" data-id="element-19738"></div>
              </div>
            </div>

            <div className="flex items-center mb-3" data-id="element-19739">
              <div className="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center text-primary mr-3" data-id="element-19740">
                <Monitor className="w-4 h-4" data-id="element-19741" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-19742">
                Баннер на главной
              </h3>
            </div>
            <p className="text-slate-600 text-sm mb-6 flex-grow" data-id="element-19743">
              Заметный блок на главной странице сайта. Максимальный охват
              аудитории.
            </p>

            <div className="bg-slate-50 p-4 rounded-xl mb-6" data-id="element-19744">
              <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-2" data-id="element-19745">
                Спецификации
              </div>
              <ul className="space-y-1 text-sm text-slate-700" data-id="element-19746">
                <li data-id="element-19747">
                  <span className="text-slate-500" data-id="element-19748">Размер:</span> 1140x250px
                </li>
                <li data-id="element-19749">
                  <span className="text-slate-500" data-id="element-19750">Формат:</span> JPG, PNG, GIF
                </li>
                <li data-id="element-19751">
                  <span className="text-slate-500" data-id="element-19752">Вес:</span> до 500 КБ
                </li>
              </ul>
            </div>

            <div className="font-bold text-xl text-slate-900" data-id="element-19753">
              от 50 000 ₽{' '}
              <span className="text-sm font-normal text-slate-500" data-id="element-19754">
                / неделя
              </span>
            </div>
          </Card>

          <Card padding="lg" className="flex flex-col" data-id="element-19755">
            <div className="w-full h-32 bg-slate-100 rounded-xl mb-6 flex flex-col items-center justify-center border border-slate-200 relative overflow-hidden" data-id="element-19756">
              {/* Mockup visual */}
              <div className="w-full h-full flex p-4 gap-4" data-id="element-19757">
                <div className="w-1/3 h-full bg-slate-200 rounded" data-id="element-19758"></div>
                <div className="w-2/3 flex flex-col gap-2" data-id="element-19759">
                  <div className="w-full h-4 bg-slate-300 rounded" data-id="element-19760"></div>
                  <div className="w-3/4 h-3 bg-slate-200 rounded" data-id="element-19761"></div>
                  <div className="w-full h-12 bg-amber-100 border border-amber-200 rounded mt-auto flex items-center justify-center text-amber-600 text-xs font-medium" data-id="element-19762">
                    Нативная вставка
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center mb-3" data-id="element-19763">
              <div className="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center text-amber-600 mr-3" data-id="element-19764">
                <FileText className="w-4 h-4" data-id="element-19765" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-19766">
                Нативная статья
              </h3>
            </div>
            <p className="text-slate-600 text-sm mb-6 flex-grow" data-id="element-19767">
              Публикация в нашем блоге с анонсом на главной странице и в
              соцсетях.
            </p>

            <div className="bg-slate-50 p-4 rounded-xl mb-6" data-id="element-19768">
              <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-2" data-id="element-19769">
                Особенности
              </div>
              <ul className="space-y-1 text-sm text-slate-700" data-id="element-19770">
                <li data-id="element-19771">
                  <span className="text-slate-500" data-id="element-19772">SEO:</span> Вечная ссылка
                  (Dofollow)
                </li>
                <li data-id="element-19773">
                  <span className="text-slate-500" data-id="element-19774">Текст:</span> Наш редактор
                </li>
                <li data-id="element-19775">
                  <span className="text-slate-500" data-id="element-19776">Бонус:</span> Анонс в
                  Telegram
                </li>
              </ul>
            </div>

            <div className="font-bold text-xl text-slate-900" data-id="element-19777">
              35 000 ₽{' '}
              <span className="text-sm font-normal text-slate-500" data-id="element-19778">
                / статья
              </span>
            </div>
          </Card>

          <Card padding="lg" className="flex flex-col" data-id="element-19779">
            <div className="w-full h-32 bg-slate-100 rounded-xl mb-6 flex flex-col items-center justify-center border border-slate-200 relative overflow-hidden" data-id="element-19780">
              {/* Mockup visual */}
              <div className="w-2/3 h-full bg-white shadow-sm border border-slate-200 flex flex-col p-2 gap-2" data-id="element-19781">
                <div className="w-full h-3 bg-slate-200 rounded" data-id="element-19782"></div>
                <div className="w-full h-12 bg-emerald-50 border border-emerald-200 rounded flex items-center justify-center text-emerald-600 text-[10px] font-medium text-center leading-tight" data-id="element-19783">
                  Ваш блок
                  <br data-id="element-19784" />в рассылке
                </div>
                <div className="w-full h-2 bg-slate-100 rounded mt-auto" data-id="element-19785"></div>
              </div>
            </div>

            <div className="flex items-center mb-3" data-id="element-19786">
              <div className="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center text-emerald-600 mr-3" data-id="element-19787">
                <Mail className="w-4 h-4" data-id="element-19788" />
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-19789">
                Email-рассылка
              </h3>
            </div>
            <p className="text-slate-600 text-sm mb-6 flex-grow" data-id="element-19790">
              Включение вашего блока в еженедельный дайджест или отдельное
              письмо.
            </p>

            <div className="bg-slate-50 p-4 rounded-xl mb-6" data-id="element-19791">
              <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-2" data-id="element-19792">
                Метрики
              </div>
              <ul className="space-y-1 text-sm text-slate-700" data-id="element-19793">
                <li data-id="element-19794">
                  <span className="text-slate-500" data-id="element-19795">База:</span> 45 000+
                  подписчиков
                </li>
                <li data-id="element-19796">
                  <span className="text-slate-500" data-id="element-19797">Open Rate:</span> ~28%
                </li>
                <li data-id="element-19798">
                  <span className="text-slate-500" data-id="element-19799">CTR:</span> ~4.5%
                </li>
              </ul>
            </div>

            <div className="font-bold text-xl text-slate-900" data-id="element-19800">
              от 25 000 ₽{' '}
              <span className="text-sm font-normal text-slate-500" data-id="element-19801">
                / выпуск
              </span>
            </div>
          </Card>
        </div>

        {/* Placement Map */}
        <h2 className="text-3xl font-bold text-slate-900 mb-4 text-center" data-id="element-19802">
          Карта размещений
        </h2>
        <p className="text-center text-slate-600 max-w-2xl mx-auto mb-8" data-id="element-19803">
          Мы предлагаем 18 рекламных слотов на различных страницах платформы,
          чтобы вы могли точно таргетировать свою аудиторию.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-20" data-id="element-19804">
          {placementMap.map((area, idx) => <Card key={idx} padding="sm" className={`border ${area.color} hover:shadow-md transition-shadow`} data-id="element-19805">
              <div className="flex items-start justify-between mb-3" data-id="element-19806">
                <div className="flex items-center gap-2" data-id="element-19807">
                  <div className="p-2 bg-white rounded-lg shadow-sm" data-id="element-19808">
                    {area.icon}
                  </div>
                  <h3 className="font-bold text-slate-900" data-id="element-19809">{area.title}</h3>
                </div>
                <Badge variant="neutral" size="sm" data-id="element-19810">
                  {area.slots} слота
                </Badge>
              </div>
              <div className="space-y-2 text-sm" data-id="element-19811">
                <div className="flex justify-between" data-id="element-19812">
                  <span className="text-slate-500" data-id="element-19813">Форматы:</span>
                  <span className="font-medium text-slate-700" data-id="element-19814">
                    {area.types.join(', ')}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-19815">
                  <span className="text-slate-500" data-id="element-19816">Охват:</span>
                  <span className="font-medium text-slate-700" data-id="element-19817">
                    {area.impressions}
                  </span>
                </div>
                <div className="flex justify-between pt-2 border-t border-slate-200/50" data-id="element-19818">
                  <span className="text-slate-500" data-id="element-19819">Бюджет:</span>
                  <span className="font-bold text-slate-900" data-id="element-19820">
                    {area.priceRange}
                  </span>
                </div>
              </div>
            </Card>)}
        </div>

        {/* Pricing Table */}
        <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center" data-id="element-19821">
          Подробный прайс-лист
        </h2>
        <Card padding="none" className="overflow-hidden mb-20 overflow-x-auto" data-id="element-19822">
          <table className="min-w-full text-left text-sm" data-id="element-19823">
            <thead className="bg-slate-50 text-slate-600 border-b border-slate-200" data-id="element-19824">
              <tr data-id="element-19825">
                <th className="px-6 py-4 font-semibold" data-id="element-19826">Формат</th>
                <th className="px-6 py-4 font-semibold" data-id="element-19827">Размещение</th>
                <th className="px-6 py-4 font-semibold" data-id="element-19828">Срок</th>
                <th className="px-6 py-4 font-semibold" data-id="element-19829">Показы (прогноз)</th>
                <th className="px-6 py-4 font-semibold text-right" data-id="element-19830">Цена</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-19831">
              {pricingData.map((row, index) => <tr key={index} className="hover:bg-slate-50 transition-colors" data-id="element-19832">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-19833">
                    {row.format}
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-19834">{row.placement}</td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-19835">{row.duration}</td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-19836">
                    {row.impressions}
                  </td>
                  <td className="px-6 py-4 font-bold text-slate-900 text-right" data-id="element-19837">
                    {row.price}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </Card>

        {/* Why Us */}
        <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center" data-id="element-19838">
          Почему мы?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-24" data-id="element-19839">
          <Card padding="lg" data-id="element-19840">
            <Target className="w-8 h-8 text-primary mb-4" data-id="element-19841" />
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-19842">Целевая аудитория</h3>
            <p className="text-sm text-slate-600" data-id="element-19843">
              Платежеспособная аудитория, активно интересующаяся саморазвитием.
            </p>
          </Card>
          <Card padding="lg" data-id="element-19844">
            <CheckCircle2 className="w-8 h-8 text-emerald-500 mb-4" data-id="element-19845" />
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-19846">
              Высокая вовлечённость
            </h3>
            <p className="text-sm text-slate-600" data-id="element-19847">
              Пользователи проводят на сайте много времени, изучая объемные
              отчеты.
            </p>
          </Card>
          <Card padding="lg" data-id="element-19848">
            <Settings className="w-8 h-8 text-amber-500 mb-4" data-id="element-19849" />
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-19850">Гибкие форматы</h3>
            <p className="text-sm text-slate-600" data-id="element-19851">
              Подберем оптимальный формат под ваши задачи и бюджет.
            </p>
          </Card>
          <Card padding="lg" data-id="element-19852">
            <BarChart className="w-8 h-8 text-indigo-500 mb-4" data-id="element-19853" />
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-19854">
              Прозрачная аналитика
            </h3>
            <p className="text-sm text-slate-600" data-id="element-19855">
              Предоставляем подробные отчеты по показам и кликам после кампании.
            </p>
          </Card>
        </div>

        {/* Contact Form */}
        <Card padding="lg" className="max-w-3xl mx-auto border-none shadow-xl" data-id="element-19856">
          <div className="text-center mb-8" data-id="element-19857">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-19858">
              Оставить заявку
            </h2>
            <p className="text-slate-600" data-id="element-19859">
              Заполните форму, и наш менеджер свяжется с вами для обсуждения
              деталей.
            </p>
          </div>

          <form className="space-y-6" data-id="element-19860">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-19861">
              <Input label="Компания / Бренд" placeholder="Название вашей компании" data-id="element-19862" />
              <Input label="Контактное лицо" placeholder="Ваше имя" data-id="element-19863" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-19864">
              <Input label="Email" type="email" placeholder="work@example.com" data-id="element-19865" />
              <Input label="Телефон" type="tel" placeholder="+7 (999) 000-00-00" data-id="element-19866" />
            </div>

            <div data-id="element-19867">
              <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-19868">
                Ориентировочный бюджет
              </label>
              <select className="block w-full rounded-xl border-slate-200 shadow-sm focus:ring-primary focus:border-primary sm:text-sm px-4 py-2.5 border outline-none text-slate-900 bg-white appearance-none" data-id="element-19869">
                <option value="" data-id="element-19870">Выберите бюджет...</option>
                <option value="under50" data-id="element-19871">До 50 000 ₽</option>
                <option value="50to200" data-id="element-19872">50 000 ₽ - 200 000 ₽</option>
                <option value="over200" data-id="element-19873">Более 200 000 ₽</option>
              </select>
            </div>

            <div data-id="element-19874">
              <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-19875">
                Комментарий или вопросы
              </label>
              <textarea rows={4} className="block w-full rounded-xl border-slate-200 shadow-sm focus:ring-primary focus:border-primary sm:text-sm px-4 py-2.5 border outline-none text-slate-900 resize-none" placeholder="Опишите ваш продукт и цели рекламной кампании..." data-id="element-19876"></textarea>
            </div>

            <div className="pt-4" data-id="element-19877">
              <Button size="lg" fullWidth type="button" onClick={() => {
              success('Заявка на рекламу отправлена! Мы свяжемся с вами в течение 24 часов.');
            }} data-id="element-19878">
                Отправить заявку
              </Button>
              <p className="text-center text-sm text-slate-500 mt-4" data-id="element-19879">
                Мы свяжемся с вами в течение 1 рабочего дня
              </p>
            </div>
          </form>
        </Card>
      </div>
    </div>;
}